export enum FormaPagamentoClassificacao {
    Desconhecido = 0,
    Dinheiro = 1,
    Cheque = 2,
    CartaoCredito = 3,
    CartaoDebito = 4,
    ContaReceber = 5,
    ContaPagar = 6,
    PixContaBancaria = 7,
    Vale = 10,
    Boleto = 15,
    Deposito = 16,
    PixContaDigital = 17,
    Transferencia = 18,
    Cashback = 19,
    PixCobranca = 66,
    CartaoCreditoCobrancaOnline = 77,
    ValeCredito = 88,
    SemPagamento = 90,
    Outros = 99,
}
